(function ($) {

    $(document).ready(function () {
        $('.section-grid-images-with-popups-blog .item').on('click', function () {
            let imgSrc = $(this).find('.rect-inner').css('background-image');

            imgSrc = imgSrc.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');

            let modalBody = $('#blogImagesGrid .modal-body');

            modalBody.html('<img src="' + imgSrc + '" class="img-fluid" alt="Modal Image">');
        });

        $('#blogImagesGrid').on('hidden.bs.modal', function () {
            $(this).find('.modal-body').html('');
        });

    });

})(jQuery);